// extracted by mini-css-extract-plugin
export default {"alignVerticalFull":"alignVerticalFull--ri2Uh","layoutPadding":"layoutPadding--xAVm4","layoutConfiguration":"layoutConfiguration--e7ohW"};